export const MEATBALL_MENU_TESTID = 'software-context-menu.meatball-menu';
